// MODIFIED
import React from "react";
import ChangeSchedulePage from "../../v2/pages/Transactions/ChangeSchedulePage";

/**
 * Legacy Wrapper for Change Schedule Module.
 * Redirects to the V2 implementation to maintain App.js compatibility.
 */
function ChangeOfSchedule({ user, userAccess, isHideSideMenu }) {
  return (
    <ChangeSchedulePage 
      user={user} 
      userAccess={userAccess} 
      isHideSideMenu={isHideSideMenu} 
    />
  );
}

export default ChangeOfSchedule;